import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem} from '@angular/cdk/drag-drop';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Md5 } from 'ts-md5/dist/md5';
import { ApiService } from '../../custom-material/Services/';
import { UserModel } from '../../main/Models';
import { globalData } from 'src/app/main/Models/global.model';
import { UsersListComponent } from '../users-list/users-list.component';

@Component({
  selector: 'rm-team',
  templateUrl: './t_team.component.html',
  styleUrls: ['./team.component.less']
})
export class TeamComponent implements OnInit {

	@Input() id:string
	@Input() users:Array<UserModel> = [];
	@Input() connectedLists:string[] = [];
	@Input() deleteOnDragOut:boolean = false;
  @Input() showAddButton:boolean = false;

	@Output() changeValue:EventEmitter<Array<UserModel>> = new EventEmitter();


  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }


  getUserColor(name:string)
  {
    return '#'+Md5.hashStr(name).slice(0,6);
  }

  dropActor(event: CdkDragDrop<UserModel[]>) {
    if(!event.isPointerOverContainer) {
    	if(this.deleteOnDragOut)
        this.users.splice(event.previousIndex,1);
    } else if (event.previousContainer === event.container) {
      //do nothing when drag-drop inside a container
     //moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      copyArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
    this.users = this.users.filter((value, index, array) => 
     !array.filter((v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index).length);

    this.changeValue.emit(this.users);
  }


  addUser()
  {
    const dialogRef = this.dialog.open(UsersListComponent, {
      width: '500px',
      data: {currentUsers: this.users.map((u:UserModel)=>{ return u.id}) }
    });

    dialogRef.afterClosed().subscribe((user) => {
      if(user) this.users.push(user);
    });
  }
}